import {
  FIELD_BASE,
  FIELD_DISABLED,
  FIELD_ERROR,
  FIELD_LABEL,
  fieldState,
} from "./formFieldStyles";

const FormTextarea = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  rows = 3,
  error,
  required = false,
  placeholder,
  disabled = false,
}) => (
  <div>
    {label && (
      <label htmlFor={name} className={FIELD_LABEL}>
        {label} {required && <span className="text-danger-500">*</span>}
      </label>
    )}

    <textarea
      id={name}
      name={name}
      rows={rows}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      className={`${FIELD_BASE} resize-y ${fieldState(error)} ${
        disabled ? FIELD_DISABLED : "text-gray-900"
      }`}
    />

    {error && <p className={FIELD_ERROR}>{error}</p>}
  </div>
);

export default FormTextarea;
